import { getApi } from '../../../comm/middleware/callApi';
import apis from '../../../comm/api/apis';
/**
 * 用户端-周刊详情页接口
 * * @param commit
 * @param dyml dayima 带过来的登录参数
 */

export const getWeeklyDetail = ({ commit }, params) => {
  return getApi({ commit }, apis.weeklyDetail, params)
    .then((body) => {
      return body.data;
    });
};
// 周刊列表数据
export const getWeeklyList = ({ commit }, params) => {
  return getApi({ commit }, apis.weeklyList, params)
    .then((body) => {
      return body.data;
    });
};
// 孕育周知免费领取权益页面内容数据
export const getShareDetail = ({ commit }, params) => {
  return getApi({ commit }, apis.shareDetail, params)
    .then((body) => {
      return body.data;
    });
};
// 用户端-- 领取周知
export const getShareWeekly = ({ commit }, params) => {
  return getApi({ commit }, apis.getShareWeekly, params)
    .then((body) => {
      return body.data;
    });
};
// 用户端-- 获取周知音视频链接
export const getWeeklyAudioUrl = ({ commit }, params) => {
  return getApi({ commit }, apis.getWeeklyAudioUrl, params)
    .then((body) => {
      return body.data;
    });
};
// 周刊播放记录写入
export const getUpdateMediaPlayLog = ({ commit }, params) => {
  return getApi({ commit }, apis.updateMediaPlayLog, params)
    .then((body) => {
      return body.data;
    });
};


export const getWeeklyCombos = ({ commit }, params) => {
  return getApi({ commit }, apis.getWeeklyCombos, params, false)
    .then((body) => {
      return body.data;
    });
};

export const buyNow = ({ commit }, params) => {
  return getApi({ commit }, apis.buyNow, params, false)
    .then((data) => {
      return getApi({ commit }, apis.submitorder, {
        areaid: 250,
        isnewsdk: 1,
        orderType: 7,
        supportaddpricebuy: 1,
        uuid: data.data
      }, false)
      .then((body) => {
        return body.data;
      }).catch(() => {
      });
    });
};

export const getSDKInfo = ({ commit }, params) => {
  return getApi({ commit }, apis.getSDKInfo, params, false)
    .then((body) => {
      return body.data;
    });
};

export const detail4payment = ({ commit }, params) => {
  return getApi({ commit }, apis.detail4payment, params, false)
  .then((order) => {
    return getApi({ commit }, apis.getPayWayList, {
      encrypteddata: order.data.encrypteddata,
      sign: order.data.sign,
      signtime: order.data.signtime,
      businessno: order.data.businessno
    }, false)
    .then((body) => {
      const data = {
        order: order.data,
        paywaylist: body.data
      };
      return data;
    });
  });
};

export const getCanBuyList = ({ commit }, params) => {
  return getApi({ commit }, apis.getCanBuyList, params, false)
  .then((body) => {
    return body.data;
  });
};

// 周刊简报
export const getItemMsg = ({ commit }, params) => {
  return getApi({ commit }, apis.getItemMsg, params, false)
  .then((body) => {
    return body.data;
  });
};

// 领取免费周刊
export const getWeeklyRight = ({ commit }, params) => {
  return getApi({ commit }, apis.getWeeklyRight, params, false)
    .then((body) => {
      return body.data;
    });
};

export const getKnowingIndex = ({ commit }, params) => {
  return getApi({ commit }, apis.geIndexInfo, params, false)
    .then((body) => {
      return body.data;
    });
};

export const getSignInfo = ({ commit }, params) => {
  return getApi({ commit }, apis.sign, params, false)
    .then((body) => {
      return body.data;
    });
};

// 兑换周刊
export const confirmExchange = ({ commit }, params) => {
  return getApi({ commit }, apis.confirmExchange, params, {}, false, false)
  .then((body) => {
    return body;
  }).catch((e) => {
    return e;
  });
};

// 兑换周刊
export const getPrePayWayList = ({ commit }, params) => {
  return getApi({ commit }, apis.prePayWayList, params, {}, false, false)
    .then((body) => {
      return body;
    }).catch((e) => {
      return e;
    });
};



// WEBPACK FOOTER //
// ./src/store/user/knowing/actions.knowing.js